import { useRouter } from 'util/router';

function useGetChainIdFromRouter(defaultChainId) {
	const router = useRouter();
	const chainId = Number(router.query.chainId || defaultChainId);
	return chainId;
};

export default useGetChainIdFromRouter;
